<app-input-text [maxLength]="maxLength" [parentFormControlName]="parentFormGroupName"
                [parentFormGroup]="parentFormGroup"></app-input-text>
